const RouteFlyModel = {
    id: "",
    name: "",
    description: "",
    panel: "",
    zone_id: "",
    zone_data: {
        id: "",
        name: "",
        polylines: [],
    },
    driver_data: {
        email: "",
    },
};
export default RouteFlyModel;
